module.exports = __webpack_public_path__ + "img/case2.ccf60b03.png";